var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "copy-icon",
    width: 10,
    height: 10,
    viewBox: "0 0 9 8",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "file-1",
    d: "M3.68717 6.00033C3.51036 6.00033 3.34079 5.93009 3.21577 5.80506C3.09075 5.68004 3.02051 5.51047 3.02051 5.33366V1.33366C3.02051 1.15685 3.09075 0.987279 3.21577 0.862254C3.34079 0.73723 3.51036 0.666992 3.68717 0.666992H6.02051L7.35384 2.00033V5.33366C7.35384 5.51047 7.2836 5.68004 7.15858 5.80506C7.03356 5.93009 6.86399 6.00033 6.68717 6.00033H3.68717Z",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "corner",
    d: "M7.35417 2.33366H6.35417C6.17736 2.33366 6.00779 2.26342 5.88276 2.1384C5.75774 2.01337 5.6875 1.8438 5.6875 1.66699V0.666992",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "file-2",
    d: "M1.6875 2.5332V6.79987C1.6875 6.94132 1.74369 7.07697 1.84371 7.17699C1.94373 7.27701 2.07938 7.3332 2.22083 7.3332H5.4875",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "assets/f78374bb85a247c7b9e2a834d001b518.svg";
export { SvgCopy as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/copy.svg